document.addEventListener("DOMContentLoaded",(function(){window.addEventListener("scroll",(function(){window.scrollY>150?(document.getElementById("navbar_top").classList.add("fixed-top"),navbar_height=document.querySelector(".navbar").offsetHeight,document.body.style.paddingTop=navbar_height+"px"):(document.getElementById("navbar_top").classList.remove("fixed-top"),document.body.style.paddingTop="0")}))}));


// WEBPACK FOOTER //
// ./scripts/minify/header.min.js